import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";
import { use } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { createLoginSuccessAction } from "../../store/actions";
import { AuthLogin, AuthRegister } from "../../API/login";
import { showLoding } from '../../utils/tool';
import { message } from "antd";
import { getQueryParam } from "../../utils/getUrlParamsLegacy";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see, setSee] = React.useState(false)
  const [see2, setSee2] = React.useState(false)
  const navigate = useNavigate()
  const token = useSelector((state: any) => state?.token)

  let dispatch = useDispatch();
  useEffect(() => {
    // 登入
    // dispatch(
    //   createLoginSuccessAction(
    //     'token',
    //     '1111111121223235465'
    //   )
    // );
    // 退出
    // dispatch(
    //   createLoginSuccessAction(
    //     '',
    //     ''
    //   )
    // );
  }, [])

  const [username, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [phone, setPhone] = React.useState('')
  const [invitationCode, setInvitationCode]: any = React.useState(getQueryParam("invitationCode"))
  const handleAuthRegister = () => {
    if (!username || !password || !phone || !invitationCode) {
      return message.error('請輸入完整資訊')
    }
    showLoding(true);
    AuthRegister({
      username: (username || '').trim(),
      password: btoa((password || '').trim()),
      invitationCode: (invitationCode || '').trim(),
      phone: (phone || '').trim(),

    }).then((res: any) => {
      dispatch(
        createLoginSuccessAction(
          'token',
          res?.data?.token
        )
      );
      setUsername1(username)
      setPassword1(password)
      setUsername('')
      setPassword('')
      setPhone('')
      setInvitationCode('')
      message.success('註冊成功，請登入')
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false);
    })
  }

  const [username1, setUsername1] = React.useState('')
  const [password1, setPassword1] = React.useState('')
  const handleAuthLogin = () => {
    if (!username1 || !password1) {
      message.error('請輸入帳號密碼')
      return
    }
    showLoding(true);
    AuthLogin({
      username: (username1 || '').trim(),
      password: btoa((password1 || '').trim()),   
    }).then((res: any) => {
      dispatch(
        createLoginSuccessAction(
          'token',
          res?.data?.token
        )
      );
      localStorage.setItem('token', res?.data?.token)
      message.success('登入成功')
      navigate('/')
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false);
    })
  }

  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full"> 
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">會員中心</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">會員中心</div>

        <div className="flex py-[75px] h5:block">
          <div className="flex-1 px-[16px]">
            <div className="text-[#181512] text-[46px] font-bold mb-[30px] h5:text-[36px]">登入</div>
            <div className="p-[20px] rounded-md"
              style={{
                border: "1px solid #cfc8d8",
              }}
            >
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  使用者手機號
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex pb-[36px]">
                  <input type="text"
                    value={username1}
                    onChange={(e) => setUsername1(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                    style={{
                      border: "1px solid #cfc8d8",
                    }} />
                </div>
              </div>
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  密碼
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} >
                  <input type={`${see ? "password" : "text"}`}
                    value={password1}
                    onChange={(e) => setPassword1(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                  <img src={
                    see ? require("../../assets/image/login/eye-close.png") :
                      require("../../assets/image/login/eye-see.png")}
                    className="w-[22px] h-[22px] cursor-pointer ml-4"
                    onClick={() => setSee(!see)}
                    alt="" />
                </div>
                <div
                  onClick={() => handleAuthLogin()}
                  className="bg-[#6d6e71] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]">
                  登入
                </div>
                <div className="py-[36px]">
                  <div className="inline-block text-[#595959] text-[18px] font-bold cursor-pointer underline"
                    onClick={() => navigate("/login/lostPassword")}
                  >忘記密碼？</div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[50px] h5:hidden"></div>
          <div className="flex-1 px-[16px]">
            <div className="text-[#181512] text-[46px] font-bold mb-[30px] h5:pt-[50px] h5:text-[36px]">註冊</div>
            <div className="p-[20px] rounded-md"
              style={{
                border: "1px solid #cfc8d8",
              }}
            >
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  使用者名稱
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex pb-[36px]">
                  <input type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                    style={{
                      border: "1px solid #cfc8d8",
                    }} />
                </div>
              </div>
              <div>
                <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                  使用者手機
                  <div className="text-[red] text-[18px] ml-10">*</div>
                </div>
                <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} >
                  <input type={`text`}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                </div>
                <div>
                  <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                    密碼
                    <div className="text-[red] text-[18px] ml-10">*</div>
                  </div>
                  <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                    style={{
                      border: "1px solid #cfc8d8",
                    }} >
                    <input type={`${see2 ? "password" : "text"}`}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                    <img src={
                      see2 ? require("../../assets/image/login/eye-close.png") :
                        require("../../assets/image/login/eye-see.png")}
                      className="w-[22px] h-[22px] cursor-pointer ml-4"
                      onClick={() => setSee2(!see2)}
                      alt="" />
                  </div>
                  <div className="flex items-center mb-[20px] text-[#181512] text-[18px]">
                    邀請碼
                    <div className="text-[red] text-[18px] ml-10">*</div>
                  </div>
                  <div className="flex items-center mb-[36px] pr-[15px] rounded-md"
                    style={{
                      border: "1px solid #cfc8d8",
                    }} >
                    <input type={`${see ? "password" : "text"}`}
                      value={invitationCode}
                      onChange={(e) => setInvitationCode(e.target.value)}
                      className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]" />
                  </div>
                  <div className="pb-[30px]">
                    您的個人資料將用於支持您在整個網站的體驗，管理對您帳戶的訪問權限以及我們
                    <div className="cursor-pointer underline text-[#2d634e] font-bold text-[18px] inline" onClick={() => navigate('/privacy')}>
                      隱私權政策
                    </div>
                    、
                    <div className="cursor-pointer underline text-[#2d634e] font-bold text-[18px] inline" onClick={() => navigate('/dataProtection')}>
                      個人資料保護政策
                    </div>
                    中描述的其他目的。
                  </div>
                  <div className="bg-[#6d6e71] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]"
                    onClick={() => handleAuthRegister()}
                  >
                    註冊
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
